import React from "react";

const Team = () => {
        return(
            <>
            
   {/* <!-- OUR TEAM START --> */}
   <div class="my-5 container"  id="team">
    <div class="text-center pt-5">
        <h2 class="pt-3">OUT TEAM</h2>
        <hr class="w-25 mx-auto "/>
        <p>Meat our experts</p>
    </div>
    <div class="row mx-auto text-center">
        <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12 text-center">
           
            <div class="mx-auto  my-3 px-auto card text-center" >
                <img src="https://media.istockphoto.com/id/1347347443/photo/hacker-seated-in-server-room-launching-cyberattack-on-laptop.jpg?b=1&s=170667a&w=0&k=20&c=5qbSopyKNjPcTPfKTCbkXR2Ryrldc46Cn2aXPB6bIVk=" class="card-img-top" alt="..."/>
                <div class="card-body">
                  <h5 class="card-title">App Development</h5>
                  {/* <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                  <a href="#" class="btn btn-outline-info">Go somewhere</a>
                </div>
              </div>
        </div>
        <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12">
            <div class="mx-auto px-auto my-3 card" >
                <img src="https://media.istockphoto.com/id/817486228/photo/dangerous-hooded-hacker-breaks-into-government-data-servers-and-infects-their-system-with-a.jpg?s=612x612&w=0&k=20&c=BPW2lh4oej-ppMJRofkZPCoOBxcZtj-_3xEgaXM-dO4=" class="card-img-top" alt="..."/>
                <div class="card-body">
                    
                  <h5 class="card-title">Web Development</h5>
                  {/* <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                  <a href="#" class="btn btn-outline-info">Go somewhere</a>
                </div>
              </div>
        </div>
        <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12">
            <div class="mx-auto my-3 px-auto card" >
                <img src="https://previews.123rf.com/images/peshkov/peshkov1903/peshkov190300593/118912874-side-view-of-hacker-using-computer-with-circuit-on-blurry-background-hacking-and-malware-concept-dou.jpg" class="card-img-top" alt="..."/>
                <div class="card-body">
                  <h5 class="card-title">GUI Development</h5>
                  {/* <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                  <a href="#" class="btn btn-outline-info">Go somewhere</a>
                </div>
              </div>
        </div>
        <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12">
            <div class="card my-3 mx-auto px-auto " >
                <img src="https://c8.alamy.com/comp/2CG37N0/computer-hacker-with-a-hood-touches-the-touch-screen-binary-code-light-waves-on-abstract-binary-software-background-hacker-silhouette-hacking-comput-2CG37N0.jpg" class="card-img-top" alt="..."/>
                <div class="card-body">
                    
                  <h5 class="card-title">Web Design</h5>
                  {/* <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                  <a href="#" class="btn btn-outline-info">Go somewhere</a>
                </div>
              </div>
        </div>
    </div>

   </div>
   {/* <!-- OUR TEAM END  --> */}

            </>
        );
};

export default Team;